import React from 'react'
import { Link } from 'react-router-dom'

export default class RegisterLink extends React.Component {
  render() {
    return (
      <Link to='/register'>
        { this.props.children ? this.props.children : 'Register'}
      </Link>
    )
  }
}
